import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { LoginTemplate } from 'components';

import { Icon } from 'semantic-ui-react';
import { Button } from 'components';

import styles from './AlreadyLogin.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class AlreadyLogin extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { mainPage, onMoveBack, onLogout } = this.props;

    return (
      <LoginTemplate>
        <div className={cx('alreadyLogin-wrapper')}>
          <div className={cx('title-text')}>
            {defineMessages(formatMessage({ id: 'AlreadyLogin_1', defaultMessage: '이미 로그인이 되어 있습니다.' }))}
          </div>
          <div className={cx('detail-text')}>
            {defineMessages(
              formatMessage({ id: 'AlreadyLogin_2', defaultMessage: '해당 작업은 로그아웃 후 이용 가능합니다.' })
            )}
          </div>
          <div className={cx('button-area')}>
            <Button buttonColor="#3cb482" fullColor onClick={onMoveBack}>
              {/* <Icon name="checkmark" />  */}
              {defineMessages(formatMessage({ id: 'AlreadyLogin_3', defaultMessage: '돌아가기' }))}
            </Button>
            <Button buttonColor="#6e6e6e" fullColor onClick={onLogout}>
              {/* <Icon name="send" />  */}
              {defineMessages(formatMessage({ id: 'AlreadyLogin_4', defaultMessage: '로그아웃' }))}
            </Button>
          </div>
        </div>
      </LoginTemplate>
    );
  }
}

AlreadyLogin.propTypes = {
  onMoveBack: PropTypes.func,
  onLogout: PropTypes.func
};
AlreadyLogin.defaultProps = {};

export default injectIntl(AlreadyLogin);



// WEBPACK FOOTER //
// ./src/script/components/login/AlreadyLogin.js